import { CardContent } from "@mui/material";
import React, { ReactNode } from "react";

export type ObjectHistoryCardContentProps = {
    children?: ReactNode;
};

export function ObjectHistoryCardContent({ children, ...rest }: ObjectHistoryCardContentProps) {
    return (
        <CardContent
            sx={{
                padding: (theme) => `0 ${theme.spacing(1)} ${theme.spacing(1)} ${theme.spacing(1)} !important`,
            }}
        >
            {children}
        </CardContent>
    );
}
